import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  AvatarStyleIndex,
  canvasBrushSize as BrushSize,
  canvasBrushSize,
} from "../constant";

const AIToolsContext = createContext(null);

export const useAIToolsContext = () => useContext(AIToolsContext);

const AIToolsProvider = ({ children }) => {
  const [selectedAITools, setSelectedAITools] = useState(null);

  // canvas
  const canvasRef = useRef(null);
  const [canvasHasChanges, setCanvasHasChanges] = useState(false);
  const [maskImage, setMaskImage] = useState(null); //base64 image
  const [brushSize, setBrushSize] = useState(canvasBrushSize.medium);

  // face swap or face correction
  const [firstSelectedImage, setFirstSelectedImage] = useState(null);
  const [firstBoundingBox, setFirstBoundingBox] = useState([]);
  const [firstBoundingBoxSelectedIndexes, setFirstBoundingBoxSelectedIndexes] =
    useState(null);
  const [firstSelectedImageServerPath, setFirstSelectedImageServerPath] =
    useState(null);

  const [secondSelectedImage, setSecondSelectedImage] = useState(null);
  const [secondBoundingBox, setSecondBoundingBox] = useState([]);
  const [
    secondBoundingBoxSelectedIndexes,
    setSecondBoundingBoxSelectedIndexes,
  ] = useState(null);
  const [secondSelectedImageServerPath, setSecondSelectedImageServerPath] =
    useState(null);

  // avatar converter
  const [selectedAvatarIndex, setSelectedAvatarIndex] = useState(
    AvatarStyleIndex.Manga
  );
  const [selectedAvatarStrengthIndex, setSelectedAvatarStrengthIndex] =
    useState(0);

  const resetAITools = useCallback(() => {
    canvasRef.current = null;
    setSelectedAITools(null);
    setCanvasHasChanges(false);
    setMaskImage(null);
    setBrushSize(BrushSize.medium);

    setFirstSelectedImage(null);
    setFirstBoundingBox([]);
    setFirstBoundingBoxSelectedIndexes(null);
    setFirstSelectedImageServerPath(null);
    setSecondSelectedImage(null);
    setSecondBoundingBox([]);
    setSecondBoundingBoxSelectedIndexes(null);
    setSecondSelectedImageServerPath(null);

    setSelectedAvatarIndex(AvatarStyleIndex.Manga);
    setSelectedAvatarStrengthIndex(0);
  }, []);

  const contextValue = useMemo(
    () => ({
      canvasRef,

      selectedAITools,
      setSelectedAITools,

      resetAITools,

      // canvas related state
      maskImage,
      setMaskImage,

      brushSize,
      setBrushSize,

      canvasHasChanges,
      setCanvasHasChanges,

      //face swap or face correction
      firstSelectedImage,
      setFirstSelectedImage,

      firstBoundingBox,
      setFirstBoundingBox,

      firstBoundingBoxSelectedIndexes,
      setFirstBoundingBoxSelectedIndexes,

      firstSelectedImageServerPath,
      setFirstSelectedImageServerPath,

      secondSelectedImage,
      setSecondSelectedImage,

      secondBoundingBox,
      setSecondBoundingBox,

      secondBoundingBoxSelectedIndexes,
      setSecondBoundingBoxSelectedIndexes,

      secondSelectedImageServerPath,
      setSecondSelectedImageServerPath,

      // avatar converter
      selectedAvatarIndex,
      setSelectedAvatarIndex,
      selectedAvatarStrengthIndex,
      setSelectedAvatarStrengthIndex,
    }),
    [
      selectedAITools,
      resetAITools,
      maskImage,
      brushSize,
      canvasHasChanges,
      firstSelectedImage,
      firstBoundingBox,
      firstBoundingBoxSelectedIndexes,
      firstSelectedImageServerPath,
      secondSelectedImage,
      secondBoundingBox,
      secondBoundingBoxSelectedIndexes,
      secondSelectedImageServerPath,
      selectedAvatarIndex,
      selectedAvatarStrengthIndex,
    ]
  );

  return (
    <AIToolsContext.Provider value={contextValue}>
      {children}
    </AIToolsContext.Provider>
  );
};

export default AIToolsProvider;
